module.exports = __webpack_public_path__ + "static/media/  (151).3ec00565.jpg";